import { Action } from '../actions/types'
import { Store } from './index'

export type CalculationState = {
  readonly jobId?: string
}

const initialState: CalculationState = {}

const reducer = (
  state: CalculationState = initialState,
  action: Action
): CalculationState => {
  switch (action.type) {
    case 'SET_JOB_ID':
      return { ...state, jobId: action.payload }

    case 'CLEAR_JOB_ID':
    case 'LOAD_PROJECT':
    case 'UPDATE_SLAB':
    case 'UPDATE_BEAM':
    case 'UPDATE_LOAD_CASE':
    case 'UPDATE_LOAD':
    case 'DELETE_LOAD':
    case 'ADD_LOAD_CASE':
    case 'DELETE_LOAD_CASE':
    case 'ADD_LOAD':
    case 'LOAD_DEFAULT_VALUES':
    case 'UNLOAD_PROJECT':
    case 'CREATE_CASE':
    case 'DELETE_CASE':
      return { ...state, jobId: undefined }

    case 'USER_LOGOUT':
      return initialState

    default:
      return state
  }
}

export function getJobId(state: Store.Complete): string | undefined {
  return state.calc.jobId
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducers/calculation.ts